<script lang="ts" setup>
import { watch } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { StatsDocument } from '@/gql/graphql';
import { BAlert, BButton, BSpinner } from 'bootstrap-vue-next';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* GRAPHQL API DETAILS ***********************************************/
const {
  result: resultFetchData,
  loading: fetchingData,
  error: errorFetchingData,
  refetch: refetchDetails,
} = useQuery(StatsDocument);

// Handle the result of the currentUser query
watch(resultFetchData, (value) => {
  console.log(value);
  if (value) {
    console.log('Stats fetched');
  } else {
    console.log('Fetching stats failed');
  }
});

/* GRAPHQL API - RE-FETCH DATA WHEN VIEW ACTIVATED ***************************/

function requestRefetchDetails() {
  refetchDetails()
    ?.catch((err) => {
      console.error('Refetching stats failed:', err);
    })
    .then(() => {
      console.log('refetched');
    });
}
</script>

<template>
  <div>
    <h1>
      <font-awesome-icon :icon="['fas', 'chart-simple']" /> Analytics Cloud
      Stats
    </h1>
    <h5>Browse stats and check cloud resource usage</h5>
    <hr />
    <!-- Content -->
    <div class="my-3">
      <!-- Debug Error Message -->
      <b-alert v-model="errorFetchingData" variant="danger" class="mt-3">
        {{ errorFetchingData }}
        <b-button
          @click="requestRefetchDetails"
          variant="outline-dark"
          class="btn-sm"
        >
          <font-awesome-icon :icon="['fas', 'sync']" />
          Retry</b-button
        >
      </b-alert>

      <!-- Loading Spinner -->
      <b-alert v-if="fetchingData" variant="info" class="mt-3">
        <b-spinner small label="Loading..." />
      </b-alert>

      <!-- Stats -->
      <div v-if="resultFetchData">
        <p>
          <strong>Organizations registered: </strong
          >{{ resultFetchData.stats?.organizations }}
        </p>
        <p>
          <strong>Users registered: </strong>{{ resultFetchData.stats?.users }}
        </p>
        <p><strong>Projects: </strong>{{ resultFetchData.stats?.projects }}</p>
        <p>
          <strong>Storage Buckets In-Use: </strong
          >{{ resultFetchData.stats?.buckets }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
